<!--
 * @Descripttion:
 * @Author: zcy
 * @Date: 2022-01-07 10:16:16
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-15 15:48:12
-->
<template>
  <div class="page-list old-page-list">
    <!-- 实时存塘量 -->
    <div class="page-search-content" ref="searchBox">
      <div class="page-big-box">
        <div class="page-search-item">
          <label>养殖场&nbsp;:</label>
          <el-select @change="baseIdChange" v-model="param.params.baseId" filterable placeholder="请选择养殖场">
            <el-option label="全部" value=""></el-option>
            <el-option :key="item.id" v-for="item in baseList" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>养殖区域&nbsp;:</label>
          <el-select @change="groupIdChange" v-model="param.params.groupId" filterable placeholder="请选择养殖区域">
            <el-option label="全部" value=""></el-option>
            <el-option :key="item.id" v-for="item in groupList" :label="item.groupName" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>养殖单元&nbsp;:</label>
          <el-select v-model="param.params.boxId" filterable placeholder="请选择养殖单元">
            <el-option label="全部" value=""></el-option>
            <el-option :key="item.id" v-for="item in boxList" :label="item.boxCode" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>养殖品种&nbsp;:</label>
          <el-select v-model="param.params.breedId" filterable placeholder="请选择养殖品种">
            <el-option label="全部" value=""></el-option>
            <el-option :key="item.id" v-for="item in breedList" :label="item.breedName" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>采样时间&nbsp;:</label>
          <el-date-picker :picker-options="pickerOptions" @change="dateSelectChange" key="date" value-format="yyyy-MM-dd"
            v-model="date" type="daterange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期">
            >
          </el-date-picker>
        </div>
      </div>
      <div class="page-search-btn">
        <div @click="search" class="search-btn">查询</div>
        <div @click="reSet" class="reset-btn">重置</div>
        <div class="search-close-btn">
          <div @click="PageSearchClose" v-if="PageDisplay">
            <span>收起</span><i class="iconfont icon-a-List-Expand"></i>
          </div>
          <div @click="PageSearchOn" v-else>
            <span>展开</span><i class="iconfont icon-List-Collapse"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- 分割线 -->
    <hr class="ufish-split-line" />
    <div class="page-echart-box">
      <div class="echart-content-box charts-content" v-show="ehcartShow">
        <div class="echart-titile navigation_tags">
          <div class="label-type">
            <span :class="[
              'title',
              ehcartActivity == true ? 'title-text-activity' : '',
            ]" @click="ehcartActivityClick(true)">采样统计-体长</span>
            <span :class="[
              'title',
              ehcartActivity == false ? 'title-text-activity' : '',
            ]" @click="ehcartActivityClick(false)">采样统计-重量</span>
          </div>
        </div>
        <div class="echart-box" ref="LineChart"></div>
      </div>
      <div style="
          display: flex;
          justify-content: center;
          padding: 15px;
          background: #fff;
        ">
        <p class="show-charts-btn" @click="ehcartShow = !ehcartShow">
          {{ ehcartShow ? "收起统计折线图" : "展开统计折线图"
          }}<i v-bind:class="ehcartShow
    ? 'iconfont icon-a-List-Expand'
    : 'iconfont icon-List-Collapse'
  "></i>
        </p>
      </div>
      <!-- <div class="echart-operation-box">
        <span @click="ehcartShowClick(true)" v-if="!ehcartShow"
          >展开统计折线图 <i class="iconfont icon-List-Collapse"></i
        ></span>
        <span @click="ehcartShowClick(false)" v-if="ehcartShow === true"
          >收起统计折线图 <i class="iconfont icon-a-List-Expand"></i
        ></span>
      </div> -->
    </div>
    <div class="page-list-content">
      <div class="page-list-title">
        <div><i class="title-icon"></i>采样记录列表</div>
        <div></div>
        <div></div>
        <div style="cursor: unset">
          <el-dropdown style="margin-right: 20px;" @command="setFixedColumn">
            <span class="el-dropdown-link">
              冻结列<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="y">冻结至"{{
                fixedColumn.label
              }}"列</el-dropdown-item>
              <el-dropdown-item command="n">取消冻结</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span @click="doExport" style="cursor: pointer"><i
              class="title-export-btn iconfont icon-a-List-Export"></i>导出</span>
        </div>
      </div>
      <el-table :data="tableData" :max-height="tableHeight" border style="width: 100%" :row-class-name="tableRowClassName"
        @header-click="handleClick">
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="baseName" label="养殖场"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[1].fixed" :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''"
          prop="groupName" label="区域分组"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[2].fixed" :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''"
          prop="boxCode" label="养殖单元"></el-table-column>
        <el-table-column :fixed="fixedColumnList[3].fixed" :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''"
          prop="typeName" label="养殖品类"></el-table-column>
        <el-table-column :fixed="fixedColumnList[4].fixed" :class-name="fixedColumnList[4].selected ? 'cellSelected' : ''"
          prop="breedName" label="养殖品种"></el-table-column>
        <el-table-column label="采样时间">
          <template slot-scope="{ row, $index }">{{
            row.samplingTime ? row.samplingTime.slice(0, 10) : ""
          }}</template>
        </el-table-column>
        <el-table-column prop="sampleNumber" label="样本数量"></el-table-column>
        <el-table-column prop="avgLength" label="平均体长(cm)"></el-table-column>
        <el-table-column prop="samWeight" label="样本重量"></el-table-column>
        <el-table-column label="平均规格"><template slot-scope="{ row, $index }">
            {{
              row.averageWeight !== null
              ? row.averageWeight +
              (row.specUnitName ? "(" + row.specUnitName + ")" : "")
              : ""
            }}</template></el-table-column>
        <el-table-column prop="putDate" label="投放日期">
          <template slot-scope="{ row, $index }">{{
            row.putDate ? row.putDate.slice(0, 10) : ""
          }}</template></el-table-column>
        <el-table-column prop="feedingDay" label="养殖天数"></el-table-column>
        <!-- 删除 日增重、肥满度 -->
        <!-- <el-table-column prop="dayDynam" label="日增重"></el-table-column>
        <el-table-column
          prop="conditionFactor"
          label="肥满度"
        ></el-table-column> -->
        <el-table-column prop="marketPrice" label="市场售价"></el-table-column>
        <el-table-column prop="storageNum" label="存箱/塘量(尾)"></el-table-column>
        <el-table-column prop="storageWeight" label="存箱/塘重量(斤)"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="uyu-pagination">
        <MyPagination @change="handleCurrentChange($event)" @changeSizes="handleSizeChange($event)"
          :sizes="[13, 26, 39, 50, 100, 200]" :pageNo.sync="pageNo" :pageSize.sync="pageSize" :totalCount="totalCount">
        </MyPagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getBaseListsByUser,
  queryBaseGroupList,
  getOrgInfoByOrgId,
  getBreedCategory,
  listDataPermissionBoxData,
  samplingInitPageList,
  samplingInitChartData,
} from "./ym-overage-services";
import MyPagination from "@/components/pc/my-pagination.vue";
import debounce from "@/utils/debounce";
import Page from "@/utils/methods/page";
import * as $echarts from "echarts";
export default {
  components: { MyPagination },
  data() {
    return {
      pageNo: 1,
      pageSize: 13,
      totalCount: 0,
      pickerOptions: {
        disabledDate(v) {
          return v.getTime() > new Date().getTime();
        },
      },
      date: [
        this.$moment().subtract(3, "months").format("YYYY-MM-DD"),
        this.$moment().format("YYYY-MM-DD"),
      ],
      // echarts的dom实例 控制折线图的注销与否
      elDom: null,
      // 折现图显示与否
      ehcartShow: false,
      // 折现图类别切换
      ehcartActivity: true,
      PageDisplay: true,
      tableTitle: "",
      tableDate: Page.getCurrentYear(),
      dateSelectNum: "1",
      value: "",
      tableData: [],
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "baseName",
          fixed: false,
          selected: false
        },
        {
          prop: "groupName",
          fixed: false,
          selected: false
        },
        {
          prop: "boxCode",
          fixed: false,
          selected: false
        },
        {
          prop: "typeName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedName",
          fixed: false,
          selected: false
        },
      ],
      param: {
        currPage: 1,
        pageSize: 13,
        totalCount: 0,
        orderBy: "desc",
        orderByName: "samplingTime",
        params: {
          orgId: "", //养殖场id
          baseId: "", //基地id
          groupId: "", //养殖区域id
          boxId: "", //单元id
          findType: "avgLength", //
          startDate: this.$moment().subtract(3, "months").format("YYYY-MM-DD"), //开始时间
          endDate: this.$moment().format("YYYY-MM-DD"), //结束时间
          breedId: "", //养殖品种id
        },
      },
      baseList: [], //养殖场data
      groupList: [], //养殖区域data
      breedList: [], //养殖品种数据
      boxList: [], //品种下拉数据
    };
  },
  created() {
    this.tableHeight = window.innerHeight - 400;
    // 时间区间控制在当天
    // this.date = [Page.getCurrentDayDate(), Page.getCurrentDayDate()];
    // echart自适应
    // debounce函数让一个方法在一定时间内只能执行一次
    this.resizeHandler = debounce(
      () => {
        this.elDom.resize();
      },
      100,
      false
    );
    // 监听浏览器窗口页面
    window.addEventListener("resize", this.resizeHandler);
  },
  mounted() {
    Page.pagesTableFixed();
    // 获取养殖场
    this.getBaseList();
  },
  // 数据监听
  watch: {
    date: function (newVal, oldVal) {
      if (newVal.length) {
        this.param.params.startDate = this.$moment(newVal[0]).format(
          "yyyy-MM-DD"
        );
        this.param.params.endDate = this.$moment(newVal[1]).format(
          "yyyy-MM-DD"
        );
      } else {
        this.param.params.startDate = "";
        this.param.params.endDate = "";
      }
    },
  },
  watch: {
    ehcartShow(nv, ov) {
      if (nv) this.initCharts(this.param);
    },
  },
  methods: {
    // 展开收起折现图事件
    ehcartShowClick(r) {
      this.ehcartShow = r;
      console.log(r);
      if (r) this.initCharts(this.param);
    },
    // echarts数据类型切换重新初始化
    ehcartActivityClick(r) {
      let type = "";
      this.ehcartActivity = r;
      // averageWeight采样统计重量 avgLength采样统计体长
      r ? (type = "avgLength") : (type = "averageWeight");
      this.param.params.findType = type;
      this.initCharts(this.param);
    },
    dateSelectChange(time) {
      if (!time) {
        return;
      }
      this.param.params.startDate = time[0];
      this.param.params.endDate = time[1];
    },
    // 监听养殖区域改变事件重新获取养殖单元
    groupIdChange(groupId) {
      this.boxList = [];
      this.param.params.boxId = "";
      this.getPermissionList(groupId);
    },
    // 监听养殖场改变事件重新获取养殖区域和养殖品种
    baseIdChange(event) {
      this.baseList.filter((item) => {
        if (event === item.id) {
          this.param.params.orgId = item.orgId;
        }
      });
      // 养殖场改变初始化数据
      this.param.params.groupId = "";
      this.groupList = [];
      this.param.params.breedId = "";
      this.breedList = [];
      this.param.params.boxId = "";
      this.boxList = [];
      // 重新获取养殖区域
      this.getBaseGroupList(this.param.params.baseId);
      // 重新获取养殖品种
      this.getOneOrgId(this.param.params.orgId);
    },
    // 获取权限下所有养殖场
    getBaseList() {
      getBaseListsByUser()
        .then((res) => {
          this.baseList = res.data;
          if (this.baseList.length) {
            this.param.params.orgId = this.baseList[0].orgId;
            this.param.params.baseId = this.baseList[0].id;
            this.getBaseGroupList(this.param.params.baseId);
            this.getOneOrgId(this.param.params.orgId);
            this.initPage(this.param);
            this.initCharts(this.param);
          }
        })
        .catch((err) => console.log(err));
    },
    // 获取养殖场下所有养殖区域
    getBaseGroupList(baseId) {
      queryBaseGroupList(baseId)
        .then((res) => {
          this.groupList = res.data;
        })
        .catch((err) => console.log(err));
    },
    // 获取养殖区域下所有养殖单元
    getPermissionList(groupId) {
      listDataPermissionBoxData(groupId)
        .then((res) => {
          this.boxList = res.data;
        })
        .catch((err) => console.log(err));
    },
    // 根据机构id获取顶级机构id
    getOneOrgId(orgId) {
      getOrgInfoByOrgId(orgId)
        .then((res) => {
          // 根据顶级机构id获取到顶级机构下所有养殖品种
          getBreedCategory(res.data.id).then((res) => {
            this.breedList = res.data;
          });
        })
        .catch((err) => console.log(err));
    },
    // pageSize改变
    handleSizeChange(pageSize) {
      this.param.currPage = 1;
      this.param.pageSize = pageSize;
      this.initPage(this.param);
      // this.initCharts(this.param)
    },
    // page改变
    handleCurrentChange(page) {
      this.param.currPage = page;
      this.initPage(this.param);
      // this.initCharts(this.param)
    },
    PageSearchClose() {
      Page.PageSearchClose(this);
    },
    PageSearchOn() {
      Page.PageSearchOn(this);
    },
    reSet() {
      this.param = {
        currPage: 1,
        pageSize: 13,
        totalCount: 0,
        orderBy: "desc",
        orderByName: "samplingTime",
        params: {
          orgId: "", //养殖场id
          baseId: "", //基地id
          groupId: "", //养殖区域id
          boxId: "", //单元id
          findType: "", //
          startDate: this.$moment().subtract(3, "months").format("YYYY-MM-DD"), //开始时间
          endDate: this.$moment().format("YYYY-MM-DD"), //结束时间
          breedId: "", //养殖品种id
        },
      };
      this.date = [
        this.$moment().subtract(3, "months").format("YYYY-MM-DD"),
        this.$moment().format("YYYY-MM-DD"),
      ];
      console.log(this.pageSize);
      this.getBaseList();
    },
    search() {
      this.initPage(this.param);
      this.initCharts(this.param);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.baseName === "合计") {
        return "heji-row";
      }
    },
    // 初始化图表
    initCharts(data) {
      samplingInitChartData(data)
        .then((res) => {
          this.elDom && this.elDom.dispose();
          let legendData = new Array();
          let xData = new Array();
          let seriesData = new Array();
          console.log(res.data);
          if (res.data.legend !== null) {
            legendData = res.data.legend.data;
          }
          xData = res.data.xAxis[0].data;
          seriesData = res.data.series;
          // 折线图初始化函数
          const option = {
            tooltip: {
              trigger: "item",
            },
            grid: {
              left: "3%",
              right: "4%",
              top: "5%",
              bottom: "60%",
              containLabel: true,
            },
            legend: {
              data: legendData,
              top: "45%",
              bottom: 0,
              itemWidth: 8,
              itemGap: 10, // 图例标记每项的间隔
            },
            xAxis: {
              type: "category",
              // name: this.translate.instant("GLOBAL_CENTRE_DATA.RIQI"),
              boundaryGap: false,
              data: xData,
              axisLine: {
                lineStyle: {
                  type: "solid",
                  color: "#DEE4E6",
                },
              },
              nameTextStyle: {
                color: "#666666",
                fontFamily: "ArialMT",
                fontWeight: "400",
              },
              axisLabel: {
                color: "#666666",
                fontFamily: "ArialMT",
                fontWeight: "400",
              },
            },
            yAxis: {
              type: "value",
              // name: this.lookChartType === "avgLength" ? "(cm)" : "",
              splitNumber: 6, // 指定坐标轴节点分割数（非强制），会按照预算自行调整最合适的分割数
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              splitLine: {
                lineStyle: {
                  type: "dashed",
                  color: "#DEE4E6",
                },
              },
              nameTextStyle: {
                color: "#666666",
                fontFamily: "ArialMT",
                fontWeight: "400",
              },
              axisLabel: {
                color: "#666666",
                fontFamily: "ArialMT",
                fontWeight: "400",
              },
            },
            series: seriesData,
          };
          let myChart = $echarts.init(this.$refs["LineChart"]);
          this.elDom = myChart;
          myChart.setOption(option);
        })
        .catch((err) => this.$message.error(err));
    },
    // 初始化列表
    initPage(data) {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      samplingInitPageList(data)
        .then((res) => {
          if (res.code == "0000") {
            this.tableData = res.data.list;
            this.pageNo = res.data.pageNumber;
            this.pageSize = res.data.pageSize;
            this.totalCount = res.data.totalCount;
          }
          setTimeout(() => {
            loading.close();
          }, 0);
        })
        .catch((err) => this.$message.error(err));
    },
    // 育苗-存塘概览报表-实时存塘量
    doExport() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(async () => {
        const param = {
          titleName: "采样数据列表",
          sheetName: "列表",
          fileName: "采样数据列表",
          param: this.param,
        };
        const flag = await Page.exportDatas(
          "/growSampling/conditionExportTable",
          param
        );
      });
      // .catch(() => {});
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
};
</script>

<style lang="less" scoped>
.old-page-list {
  height: calc(~"100% - 90px");
}

.el-pagination {
  margin-top: 20px;
}

.page-list-content {
  margin-top: unset;
}

.page-echart-box {
  box-sizing: border-box;
  // margin-top: 10px;
  // padding: 0px 34px 0px 34px;
  width: 100%;
  background: white;

  .echart-content-box {
    height: 400px;
    // width: 100%;
    background: white;

    .echart-titile {
      color: rgba(201, 201, 201, 1);

      .title-icon {
        display: inline-block;
        width: 3px;
        height: 12px;
        background: #5574fa;
        margin-right: 10px;
      }

      .title {
        font-size: 14px !important;
        font-family: MicrosoftYaHei !important;
        font-weight: 700 !important;
        cursor: pointer;
      }

      .title-text-activity {
        cursor: unset !important;
        color: #0232ff !important;
      }
    }

    .echart-box {
      width: 100%;
      height: calc(~"100% - 30px");
      background: white;
    }
  }

  .echart-operation-box {
    text-align: center;
    font-size: 14px;
    width: 100%;

    span {
      color: #0232ff;
      cursor: pointer;
    }
  }
}

.uyu-pagination {
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.navigation_tags {
  width: 100%;
  height: 83px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  >div:first-child {
    float: left;
    // margin-top: 24px;
    font-size: 14px;
    font-size: 14px;
    font-family: "MicrosoftYaHei";
    font-weight: 400;
    color: rgba(35, 38, 52, 1);

    >span {
      display: block;
      float: left;
      cursor: pointer;
      margin-right: 40px;

      &:not(:last-child) {
        position: relative;

        &::after {
          position: absolute;
          content: "";
          width: 1px;
          height: 12px;
          background-color: rgba(221, 221, 221, 1);
          top: 4px;
          right: -20px;
        }
      }
    }

    >span:last-child>button {
      float: left;
      border: none;
      outline: none;
      background-color: transparent;
      box-shadow: none;
      font-size: 14px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: #abadb3;
    }

    >span:last-child>button:hover {
      border-bottom: 1px solid #abadb3;
      height: 17px;
    }
  }

  .btn_selected {
    font-size: 14px !important;
    font-family: "MicrosoftYaHei" !important;
    font-weight: bold !important;
    color: #0232ff !important;

    &:hover {
      border-bottom: 1px solid #0232ff !important;
    }
  }

  .label-type {
    position: relative;
    padding-left: 10px;

    &::after {
      content: "";
      position: absolute;
      display: inline-block;
      width: 3px;
      height: 12px;
      background: #5574fa;
      margin-right: 10px;
      left: 0;
      top: 4px;
    }
  }
}

.chart-search-item {
  min-width: 260px;

  /deep/input {
    height: 34px !important;
    border-radius: 2px;
  }

  // 日期选择器字体图标居中
  /deep/.el-input {
    .el-input__icon {
      line-height: 34px;
    }
  }

  /deep/.el-input__inner {
    border: 1px solid #dcdfe6;
  }

  display: flex;
}

.show-charts-btn {
  cursor: pointer;
  font-size: 14px;
  color: #0232ff;

  i {
    font-size: 13px;
    display: inline-block;
    margin-left: 5px;
  }
}

.chart_text {
  font-family: "SimSun";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
}

.chart_icon {
  display: inline-block;
  width: 9px;
  height: 9px;
  border-radius: 2px;
  margin-right: 6px;
  margin-left: 30px;
}

.charts-content {
  background-color: #fff;
  padding: 0px 34px 38px 34px;
  height: 325px;

  .charts_info {
    background-color: transparent;
    height: calc(100% - 83px);
    width: 100%;
  }
}

.page-list .page-list-content {
  margin-top: 0px;
}

.ufish-split-line {
  margin: 0;
  padding: 0;
  border: 0;
  border-top: 1px solid #eee;
}
</style>



